"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2406],{

/***/ 52406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39653);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58598);
/* harmony import */ var src_containers_GenericModalContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31457);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









const HowNltWorksSectionMobile = ({
  image,
  itemsTitle,
  items,
  description,
  descriptionTitle,
  hrefTitle,
  content
}) => {
  const {
    isOpen,
    onOpen,
    onClose
  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useDisclosure */ .qY)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .VStack */ .gC, {
    spacing: -130,
    align: "stretch",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
      bg: "primaryGreen.800",
      p: "l",
      pb: "8rem",
      pos: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .H2Title */ .kY, {
        mr: "5",
        mb: "7",
        fontSize: "1.5rem",
        lineHeight: "1.938rem",
        children: descriptionTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
        fontFamily: "Montserrat-Medium",
        fontSize: "1rem",
        lineHeight: "1.425rem",
        textAlign: "left",
        color: "baseWhite",
        mt: ".75rem",
        children: description
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
      p: "l",
      zIndex: "2",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: image,
        alt: itemsTitle,
        width: "593",
        height: "358",
        objectFit: "contain",
        loading: "lazy",
        decoding: "async",
        className: "rounded"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
      bg: "baseWhite",
      p: "l",
      pt: "8rem",
      textAlign: "left",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .H2Title */ .kY, {
        color: "baseDark",
        fontSize: "1.125rem",
        lineHeight: "1.463rem",
        children: itemsTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .ListWithIcons */ .S$, {
        items: items,
        color: "baseDark",
        fontSize: "0.875rem"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
        fontFamily: "Montserrat-Medium",
        color: "baseDark",
        onClick: onOpen,
        children: [hrefTitle, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_7__/* .ArrowForwardIcon */ .mr, {})]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_containers_GenericModalContainer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onClose: onClose,
        title: content.title,
        children: content.text
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (HowNltWorksSectionMobile);

/***/ }),

/***/ 31457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_GenericModalContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(83292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/GenericModal/index.tsx





const GenericModal = ({
  children,
  title,
  isOpen,
  onClose
}) => /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Modal */.u_, {
  onClose: onClose,
  isOpen: isOpen,
  size: {
    base: 'full',
    md: 'xl'
  },
  isCentered: true,
  closeOnOverlayClick: true,
  scrollBehavior: "inside",
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ModalOverlay */.ZA, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* ModalContent */.hz, {
    backgroundColor: "baseNeutral.100",
    minWidth: {
      base: null,
      md: '890px'
    },
    borderRadius: {
      base: '0',
      sm: '10px'
    },
    px: {
      base: 'xl',
      md: 'xxl'
    },
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ModalHeader */.xB, {
      borderBottom: "1px solid #dadde1",
      fontFamily: "Montserrat-SemiBold",
      px: "0",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ModalCloseButton */.ol, {
      mt: "1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ModalBody */.fe, {
      m: "0",
      px: "0",
      pb: "xl",
      pt: "0",
      children: typeof children === 'string' ? /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Regular",
        color: "baseDark",
        className: "landing-text",
        dangerouslySetInnerHTML: {
          __html: children
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Regular",
        color: "baseDark",
        children: children
      })
    })]
  })]
});

/* harmony default export */ var components_GenericModal = (GenericModal);
;// CONCATENATED MODULE: ./src/containers/GenericModalContainer.tsx




const GenericModalContainer = ({
  title,
  children,
  isOpen,
  onClose
}) => /*#__PURE__*/(0,jsx_runtime.jsx)(components_GenericModal, {
  title: title,
  isOpen: isOpen,
  onClose: onClose,
  children: children
});

/* harmony default export */ var containers_GenericModalContainer = (GenericModalContainer);

/***/ })

}]);